import { OrderGroupDetailed } from 'src/reactQuery/orders/interfaces/orderGroup.interface';
import { API_URL_M7, getCachedSessionId } from 'src/services/common';
import { apiM7 } from 'src/util/axios-instance';

export const downloadVacationBalanceCsv = async (params: {
  projectId: string;
}): Promise<OrderGroupDetailed[] | undefined> => {
  const response = await apiM7.get<OrderGroupDetailed[]>(
    `${API_URL_M7}/api_admin/v1/intranet/holiday/report/csv?projectId=${params.projectId}`,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  // @ts-ignore
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `vacation_balance.csv`);
  document.body.appendChild(link);
  link.click();

  return response.data;
};
